import { Modal } from 'ant-design-vue';
import {marked} from 'marked';
import hljs from 'highlight.js';
import 'highlight.js/styles/foundation.css';


export const markdownToHtml = (text)=> {
    const render = new marked.Renderer();
    marked.setOptions({
        renderer: render, // 这是必填项
        gfm: true,	// 启动类似于Github样式的Markdown语法
        breaks: true,
        // pedantic: false, // 只解析符合Markdwon定义的，不修正Markdown的错误
        // sanitize: false, // 原始输出，忽略HTML标签（关闭后，可直接渲染HTML标签）,
        smartLists: true,
        smartypants: false,
        xhtml : false,
        // 高亮的语法规范
        highlight: (code, lang) => hljs.highlight(code, { language: lang }).value,
    });
    return typeof text === 'string'? marked(text): text;
};

export const markdownToJson = (el)=>{
    if(typeof text === 'string') {
        var obj = {
            tag: el.tagName.toLowerCase()
        };

        if (el.attributes.length > 0) {
            obj.attributes = {};
            Array.prototype.slice.call(el.attributes).forEach(function (attr) {
                obj.attributes[attr.name] = attr.value;
            });
        }

        var children = [];

        Array.prototype.slice.call(el.childNodes).forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
                children.push(markdownToJson(node));
            } else if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
                children.push(node.nodeValue.trim());
            }
        });

        if (children.length > 0) {
            obj.children = children;
        }

        return obj;
    }
    return el;
}
export const setState = (obj, values, func) => {
    console.log('setState')
    if(values === null){
        console.log('空')
    }
    else if(typeof values === 'object'){
        Object.keys(values).map(k=>{
            obj[k] = values[k];
        })
    }
    if(func) func();
};
// 发消息
export const jy_tip = (content, level='info') => {
    Modal[level]({content});
};